<template>
<div>
  <el-row type="flex" class="title-bar">
    <w-perf-analysis-time-info v-if="!operationFlag" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataLoad"/>
  </el-row>
  <el-row :gutter="15">
    <el-col :span="12" class="list form-list">
      <el-form :model="formList" status-icon label-width="30%" label-position="left">
        <el-form-item v-for="item in formTemplate" :key="item.prevLabel" :label="item.prevLabel" :prop="item.prevProp">
            <span v-if="item.prevBandwidthConversion">{{getBandwidthConversion(formList[item.prevProp])}}</span>
            <span v-else-if="item.prevStateConversion">{{getStateConversion(formList[item.prevProp])}}</span>
            <span v-else>{{getValueAfterCheckEmpty(formList[item.prevProp])}}</span>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col :span="12" class="list form-list">
      <el-form :model="formList" status-icon label-width="30%" label-position="left">
        <el-form-item v-for="item in rscFormTemplate" :key="item.nextLabel" :label="item.nextLabel" :prop="item.nextLabel">
          <span v-if="item.nextRateConversion">
            IN {{getRateConversion(formList[item.nextInProp])}} / OUT {{getRateConversion(formList[item.nextOutProp])}}
          </span>
          <span v-else-if="item.nextInProp === 'portPowerConsumed'">
            {{ getSecondConversion(formList[item.nextInProp] )}}
          </span>
          <span v-else>
            IN {{getSecondConversion(formList[item.nextInProp])}} / OUT {{getSecondConversion(formList[item.nextOutProp])}}
          </span>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</div>
</template>
<script>
import { isEmpty, filter } from 'lodash';
import { convertValuByUnit, convertValueForInterfaceSpeed } from '@/utils/number';
import { analysisTimeType } from '@/constants/performance';
import { objtype } from '@/constants/objtype';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import isNil from 'lodash/isNil';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

const formTemplate = [
  {
    prevLabel: '장비명',
    prevProp: 'parentObjName',
    nextLabel: 'bps',
    nextInProp: 'bpsIn',
    nextOutProp: 'bpsOut',
  },
  {
    prevLabel: '인터페이스명',
    prevProp: 'netinterfaceName',
    nextLabel: 'pps',
    nextInProp: 'ppsIn',
    nextOutProp: 'ppsOut',
  },
  {
    prevLabel: 'Oper 상태',
    prevProp: 'netinterfaceStatusOper',
    prevStateConversion: true,
    nextLabel: '이용률',
    nextInProp: 'userateIn',
    nextOutProp: 'userateOut',
    nextRateConversion: true,
  },
  {
    prevLabel: 'Admin 상태',
    prevProp: 'netinterfaceStatusAdmin',
    prevStateConversion: true,
    nextLabel: '에러율',
    nextInProp: 'errorIn',
    nextOutProp: 'errorOut',
    nextRateConversion: true,
  },
  {
    prevLabel: '별칭',
    prevProp: 'netinterfaceAlias',
    nextLabel: '기각율',
    nextInProp: 'discardIn',
    nextOutProp: 'discardOut',
    nextRateConversion: true,
  },
  {
    prevLabel: '인터페이스 IP',
    prevProp: 'netinterfaceIpaddress',
    nextLabel: 'Broadcast pps',
    nextInProp: 'ppsBIn',
    nextOutProp: 'ppsBOut',
  },
  {
    prevLabel: 'VLAN 정보',
    prevProp: 'netinterfaceVlan',
    nextLabel: 'Multicast pps',
    nextInProp: 'ppsMIn',
    nextOutProp: 'ppsMOut',
  },
  {
    prevLabel: '대역폭',
    prevProp: 'netinterfaceSpeed',
    prevBandwidthConversion: true,
    nextLabel: '사용 전력량',
    nextInProp: 'portPowerConsumed',
  },
  {
    prevLabel: 'DUPLEX',
    prevProp: 'netinterfaceDuplex',
  },
];
export default {
  name: 'WLineStatusTable',
  components: {
    WPerfAnalysisTimeInfo,
  },
  props: {
    formData: {
      type: Object,
    },
    operationFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      analysisTimeType,
      formTemplate,
      checkDatetime: null,
      formList: null,
    };
  },
  computed: {
    selectedNode() {
      return this.$store.getters.selectedNode;
    },
    rscFormTemplate() {
      return filter(this.formTemplate, (item) => !isEmpty(item.nextLabel) && (item.nextInProp !== 'portPowerConsumed' || this.selectedNode.parentObjtypeId === objtype.POE));
    },
  },
  watch: {
    formData: {
      handler() {
        if (this.formData.timeType === this.analysisTimeType.HIST.value && !this.operationFlag) {
          if (!isEmpty(this.formData.snapshotDoc)) {
            this.formList = this.formData.snapshotDoc[0];
          } else {
            this.formList = {};
          }
        } else if (!isEmpty(this.formData.currentList)) {
          this.formList = this.formData.currentList[0];
        } else {
          this.formList = {};
        }
        this.checkDatetime = this.formData.timestamp;
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * [getBandwidthConversion 대역폭 값 설정]
     * @author {Yang}
     */
    getBandwidthConversion(bps) {
      return isNil(bps) ? EMPTY_TEXT : convertValueForInterfaceSpeed(bps);
    },
    /**
     * [getStateConversion 상태 변환]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getStateConversion(value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      } else if (value === '1' || value === 1) {
        return 'UP';
      }
      return 'DOWN';
    },
    /**
     * [getRateConversion 이용률, 에러율, 기각율 2째 자리수 까지 출력]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getRateConversion(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, '%', true);
    },
    getSecondConversion(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null, true);
    },
    onTimeTypeChange(value) {
      this.$emit('time-type-change', value);
    },
    onCurrentDataLoad() {
      this.$emit('reload');
    },
    getValueAfterCheckEmpty,
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netinterface/components/LineStatusTable.vue